module.exports = __webpack_public_path__ + "media/images/views/job/save-search-tooltip-19feb0d3790bbac9cb8af2c381a322fd.gif";